import React from 'react';

import Email from './email';

import type { Activity } from 'bundles/apex/activities/types';

interface Props {
  activity: Activity;
  autoExpand?: boolean;
}

export default function ActivityEmailThread({ activity, autoExpand }: Props) {
  return <>
    {activity.emails.map(email => (
      <Email
        autoExpand={autoExpand && email.id === activity.id}
        email={email}
        key={email.id}
      />
    ))}
  </>;
}
